import React, { createContext, useContext, useMemo } from "react"
import type { PropsWithChildren } from "react"

type ArticleOverviewRoute = {
  activeCategory: string | null
  categoryTabs: Storyblok.ArticleCategoryTab[]
  overviewBasePath: string
}

const ArticleOverviewRouteContext = createContext<ArticleOverviewRoute | null>(
  null
)

export const ArticleOverviewRouteProvider = ({
  activeCategory,
  categoryTabs,
  overviewBasePath,
  children,
}: PropsWithChildren<ArticleOverviewRoute>) => {
  const articleOverviewRoute = useMemo(
    () => ({ activeCategory, categoryTabs, overviewBasePath }),
    [activeCategory, categoryTabs, overviewBasePath]
  )

  return (
    <ArticleOverviewRouteContext.Provider value={articleOverviewRoute}>
      {children}
    </ArticleOverviewRouteContext.Provider>
  )
}

export const useArticleOverviewRoute = () =>
  useContext(ArticleOverviewRouteContext)
